module.exports = __webpack_public_path__ + "static/media/webiniar.7300828b.png";